var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "67px",
    viewBox: "0 0 106 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#376B7E",
    fillRule: "nonzero",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#376B7E",
    fillRule: "nonzero",
    x: 42.5,
    y: 0.5,
    width: 21,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#376B7E",
    fillRule: "nonzero",
    x: 66.5,
    y: 0.5,
    width: 39,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "MessageParser",
    fill: "#386C7E",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 9
  }, "MessageParser")), /*#__PURE__*/React.createElement("text", {
    id: "Config",
    fill: "#386C7E",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 9
  }, "Config")), /*#__PURE__*/React.createElement("text", {
    id: "ActionProvider",
    fill: "#386C7E",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69,
    y: 9
  }, "ActionProvider")), /*#__PURE__*/React.createElement("path", {
    d: "M20,15 L20,32.5",
    id: "Line-2",
    stroke: "#376B7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,32.5 L20,32.5",
    id: "Line-2",
    stroke: "#376B7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,15 L52,32.5",
    id: "Line-2",
    stroke: "#376B7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,15 L85,32.5",
    id: "Line-2",
    stroke: "#376B7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#376B7E",
    fill: "#376B7E",
    fillRule: "nonzero",
    cx: 52.5,
    cy: 56.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Bot",
    fill: "#FFFFFF",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 58
  }, "Bot")), /*#__PURE__*/React.createElement("path", {
    d: "M52,32.5 L52,46.5",
    id: "Line-2",
    stroke: "#376B7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotOverview);
export default __webpack_public_path__ + "static/media/bot-overview.0764913e696288cdbacc8cadcec12395.svg";
export { ForwardRef as ReactComponent };